/**
 * login js
 */
import Vue from 'src/views/base'
import { Component } from 'vue-property-decorator'
import template from './login.vue'
import { Store as UserStore } from 'store/modules/user'
import { getToken } from 'common/auth'
import Cookies from 'js-cookie'
import 'common/gt.js'
import { Message } from 'element-ui'
import newHeader from 'src/views/components/new-header'
import config from 'common/config'
import jsQR from 'jsqr'

@Component({
    name: 'login',
    mixins: [template],
    components: {
        newHeader
    }
})

export default class Login extends Vue {
    @UserStore.getter('user') user
    @UserStore.getter('userInfo') userInfo
    @UserStore.action('setUser') setUser
    @UserStore.action('setRedirectUrl') setRedirectUrl
    formName = 'loginForm'
    originVerifyCode = null
    errorText = ''
    img = ''
    expire = true
    qrcodeInterval = ''
    defForm = {
        username: '',
        password: '',
        code: '',
        verifyCode: null
    }
    sevenChecked = false
    loginType = true
    form = { ...this.defForm }

    rules = {
        username: [
            { required: true, message: '请输入账号或手机号', trigger: 'blur' }
        ],
        password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        code: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        validVerifyCode: (rule, value, callback) => {
            if (this.utils.isEmpty(value)) {
                return callback(new Error('请输入验证码'))
            }
            if (!this.utils.isEmpty(rule.code)) {
                if (rule.code !== value) {
                    return callback(new Error('验证码不正确'))
                }
            }
            callback()
        }
    }

    verifyImage = ''
    needVerify = false
    verifyCodeArr = ['-110115', '-110118']
    sevenDay = null
    isShowLoading = true

    disabled = false
    isFlag = true
    isMessage = false
    isCode = false
    time = 59

    created () {
        this.autoLogin()
        /**
         *  检测到7天内自动登录即执行登录操作
         */
        this.sevenDay = Cookies.get('sevenDay')
        if (this.sevenDay) {
            let obj = JSON.parse(Cookies.get('sevenDay'))
            this.form.username = obj.loginName
            this.form.password = obj.loginPwd
            setTimeout(() => {
                this.submitForm()
            })
        }
        // this.initPublicKey()
        this.getQrcode()
        // 登录页面如果带上了重定向地址 则将重定向地址缓存起来
        const redirectUrl = this.$route.query.redirect_url
        this.setRedirectUrl(redirectUrl)
    }

    isTransition = true

    submitForm () {
        this.$refs[this.formName].validate((valid) => {
            if (valid) {
                console.log(this.sevenDay)
                this.btnLoading = true
                this.disabled = true

                if (this.isMessage) {
                    this.msgLogin()
                } else { 
                    this.encryptParam()
                }
            }
        })
    }

    encryptParam(value) {
        const vm = this
        const password = this.sevenDay ? JSON.parse(this.sevenDay).loginPwd : this.form.password
        const params = {
            username: this.sevenDay ? JSON.parse(this.sevenDay).loginName : this.form.username,
            encryptedPassword: '',
            clienttype: '3'
        }
        window.ucjssdk.utils.encryptParam({
            param: password,
            onSuccess: function (data) {
                let reg = /\+/g
                params.encryptedPassword = data.result.replace(reg, '%2B')
                vm.passwordLogin(params)
            },
            onFail: function (data) {
                console.log(data)
                alert('加密失败')
            }
        })
    }

    passwordLogin(params) {
        this.api.userApi.login(params).then((data) => {
            this.btnLoading = false
            this.disabled = false
            /**
             * 判断是否有 redirectUrl ，如果有说明是从首页跳转过来，登录成功后再跳转回 首页 相关页面
             */
            if (data.code === 200) {
                // Cookies.set('lz_token', data.result.access_token, { expires: 3, domain: this.config.api.domain })
                this.setToken(data.result.access_token)
            } else if (data.code === 4007) {
                Message({
                    message: data.msg || '连续登录失败次数超过三次（包含三次），账号被锁定十分钟，如要继续使用，请联系管理员解锁！',
                    type: 'error'
                })
            } else { 
                Message({
                    message: data.message || '网络错误',
                    type: 'error'
                })
            }
        })
    }

    msgLogin() {
        this.api.userApi.smslogin({
            username: this.form.username,
            password: this.form.code,
            grant_type: 'password',
            clienttype: '3',
            extension: { 
                type: 5,
                registerType: this.$route.query.registerType || 4,
                autoRegist: true,
                clienttype: '3'
            },
            checkPhone: false
        }).then((data) => {
            this.btnLoading = false
            this.disabled = false
            // Cookies.set('lz_token', data.access_token, { domain: this.config.api.domain })
            this.setToken(data.access_token)
        }).catch(() => {
            this.btnLoading = false
            this.disabled = false
        })
    }

    setToken(token) {
        let redirectUrl = this.$route.query.redirect_url
        let authtype = this.$route.query.auth_type
        const vm = this
        window.ucjssdk.sso.settoken({
            token: token,
            onSuccess: function (data) {
                if (redirectUrl) {
                    redirectUrl = redirectUrl.replaceAll('#authtoken', token)
                    if (authtype === 'openapi') {
                        redirectUrl = `${config.api.openapi}?token=${token}&url=${encodeURIComponent(redirectUrl)}`
                        location.href = redirectUrl
                        return
                    }
                    location.href = decodeURIComponent(redirectUrl)
                } else {
                    vm.toLZY()
                }
            },
            onFail: function (data) {
                console.log(data)
            }
        })
    }

    getQrcode() {
        this.img = config.api.host + '/api/v1/uccall/qrcodeLogin/getQrcode'
    }

    refreshQrcode() {
        clearInterval(this.qrcodeInterval)
        this.$router.go(0)
    }
    discern(e) {
        var img = e.currentTarget || e.target
        var canvas = document.createElement('canvas')
        // 获取绘画上下文
        var ctx = canvas.getContext('2d')

        // 获取图片宽高
        var imgWidth = img.width
        var imgHeight = img.height

        // 设置画布宽高与图片宽高相同
        canvas.width = imgWidth
        canvas.height = imgHeight

        // 绘制图片
        ctx.drawImage(img, 0, 0, imgWidth, imgHeight)
        // 图片展示的 data URI
        var imageData = ctx.getImageData(0, 0, img.width, img.height)
        const qrData = jsQR(imageData.data, img.width, img.width)
        console.log(JSON.parse(qrData.data.replace('lingzhu://', '')))

        const sid = JSON.parse(qrData.data.replace('lingzhu://', '')).data.sid
        this.qrcodeInterval = setInterval(() => {
            this.api.userApi.getToken({ sid }).then(res => {
                if (res.status === 1) {
                    clearInterval(this.qrcodeInterval)
                    this.expire = false
                    Cookies.set('lz_token', res.result.pcToken, { domain: this.config.api.domain })
                    this.toLZY(res.result.pcToken)
                    // window.qrcodeLogin(JSON.stringify(res.result))
                }
            })
            this.api.userApi.checkExpire({ sid }).then(res => {
                this.expire = res.result
            })
        }, 3000)
    }

    toLZY(token) { 
        location.href = `${this.config.api.LZY}/#/board` 
    }

    getCode() { 
        const vm = this
        vm.$refs[this.formName].validateField('username', (errorMessage) => { 
            if (!errorMessage) {
                vm.api.userApi.sendLoginSms({
                    phone: vm.form.username,
                    checkPhone: false
                }).then((data) => {
                    if (data.code !== 200) {
                        return Message({
                            message: data.message || '网络错误',
                            type: 'error'
                        })
                    }
                    vm.isCode = true
                    let timing = setInterval(() => {
                        vm.time--
                        if (vm.time === 0) {
                            clearInterval(timing)
                            vm.time = 59
                            vm.isCode = false
                        }
                    }, 1000)
                })
            }
        })
    }

    changeLoginType(boolean) {
        this.$refs[this.formName].clearValidate()
        this.isMessage = boolean
    }

    forgotPassword () {
        this.goTo('/forget-password')
    }

    toRegistry () {
        this.goTo('/registry')
    }

    getVerifyCode () {
        this.isTransition = false
        this.api.userApi.getVerifyCode().then((data) => {
            this.form.userIdGt = data.userIdGt  // 设置待传入的 userIdGt
            setTimeout(() => {
                this.initGeetest(data)  // 初始化验证控件
            }, 400)
        })
    }

    initGeetest (data) {
        window.initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            offline: !data.offline,
            new_captcha: true,
            https: true,
            product: 'float',
            width: '100%'
        }, (captchaObj) => {
            captchaObj.appendTo('#captchaBox')
            captchaObj.onReady(() => {
                this.isShowLoading = false
            }).onSuccess(() => {
                this.disabled = false
                this.errorText = ''
                let result = captchaObj.getValidate()
                Object.assign(this.form, result)
            }).onError(() => {

            })
        })
    }
    autoLogin() {
        // 用户已登录 直接登录
        if (!this.utils.isEmpty(getToken())) {
            // 用户状态为未激活
            if (this.userInfo.userStatus === 0) {
                this.goTo('/un-active')
            } else {
                // 用户控制中心
                location.href = this.config.api.HOME + '/dashboard'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/login/index.js